import MainLayout from "@/components/Layout/MainLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const tutorials = [
  {
    title: "Owner Portal — Full Flow",
    file: "/tutorials/02-owner-full-flow.webm",
    description:
      "Complete walkthrough of the building owner experience: login, dashboard overview, unit management, people & role assignment, top-up, bills, contracts, settings, and sign-out.",
  },
  {
    title: "Concierge Portal — Full Flow",
    file: "/tutorials/01-concierge-full-flow.webm",
    description:
      "Complete walkthrough of the concierge experience: login, dashboard overview, apartment management, viewing tenant bills and consumption data, settings, and sign-out.",
  },
];

const Demo = () => {
  return (
    <MainLayout>
      <div className="container max-w-5xl py-8 space-y-8">
        <div>
          <h1 className="text-3xl font-bold mb-2">EMA Platform Demos</h1>
          <p className="text-muted-foreground">
            Video tutorials showing how to use the Energy Management Application
            for each role.
          </p>
        </div>

        {tutorials.map((t) => (
          <Card key={t.file}>
            <CardHeader>
              <CardTitle>{t.title}</CardTitle>
              <p className="text-sm text-muted-foreground">{t.description}</p>
            </CardHeader>
            <CardContent>
              <video
                controls
                preload="metadata"
                className="w-full rounded-lg border"
                src={t.file}
              >
                Your browser does not support the video tag.
              </video>
            </CardContent>
          </Card>
        ))}
      </div>
    </MainLayout>
  );
};

export default Demo;
